import {Box} from '@mui/material';

import {useEffect, useRef, useState} from 'react';
import ChartPie from 'src/sections/_examples/extra/chart-view/chart-pie';
import RCMDashboardTable from '../RCMDashboardTable';
import {fetchChartColors} from 'src/utils/chart_utils';

const RCMDenialsComponent = ({data, chartData, ...props}: any) => {
  const [chartColors, setChartColors] = useState<any>({});
  const pieChartRef = useRef<any>(null);

  useEffect(() => {
    // Fetch colors after charts are rendered
    const refList: any = [
      {
        ref: pieChartRef,
        type: 'pie',
        name: 'pie_chart_01'
      }
    ];
    setTimeout(() => {
      /** Function to retrieve chart colors */
      fetchChartColors(setChartColors, refList);
    }, 500);
  }, [chartData]);

  return (
    <>
      <ChartPie
        chartRef={pieChartRef}
        width={500}
        chartOptionsObj={{
          dataLabels: {
            enabled: true,
            // formatter: function (val: number, opts: any) {
            //   return `$${val.toFixed(2)}`; // Add $ before value with 2 decimal places
            // },
            dropShadow: {
              enabled: false
            }
          },
          tooltip: {
            fillSeriesColor: false,
            y: {
              formatter: function (val: number) {
                return `$${val.toFixed(2)}`; // Add $ in the tooltip as well
              }
            }
          },
          ...chartData?.pie_chart_01
        }}
        series={chartData?.pie_chart_01?.series ?? []}
      />
      {chartColors?.pie_chart_01 ? (
        <Box sx={{mt: 5}}>
          <RCMDashboardTable
            addOnRows={['Grand Total', 'Percentage']}
            data={{
              ...chartData?.table_data_01,
              colors: chartColors?.pie_chart_01
            }}
            valueFormatter={'currency'}
          />
        </Box>
      ) : null}
    </>
  );
};

export default RCMDenialsComponent;
